var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_detail_homologation)?_c('Header'):_vm._e(),_c('router-view',{class:_vm.is_detail_homologation && 'content-wrapper px-3'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }